<template>
  <scoped>
    <div class="vertical-navigator">
      <div class="content">
        <slot />
      </div>
      <div class="horizontal-menu">
        <Button
          title="Home"
          :image="require('@/images/home_icon.png')"
          @click="redirect('index')"
        />
        <Button
          title="Customers"
          @click="redirect('customers')"
        />
        <Button
          title="Suppliers"
          @click="redirect('suppliers')"
        />
        <Button
          title="Trademarks"
          @click="redirect('trademarks')"
        />
        <Button
          title="Deliverables"
          @click="redirect('deliverables')"
        />
        <Button
          title="Purchase Orders"
          @click="redirect('purchase_order_overview')"
        />
        <Button
          title="Sale Orders"
          @click="redirect('sale_order_overview')"
        />
        <Button
          title="Finances"
          @click="redirect('finances')"
        />
        <Button
          title="Session"
          :image="require('@/images/account_icon.png')"
          @click="redirect('session')"
        />
      </div>
      <div class="logo">
        <a
          href="https://www.computerinfor.nl"
          target="_blank"
        >
          <img
            alt="ComputerInfor"
            src="@/images/computerinfor_logo.png"
          >
        </a>
      </div>
      <div class="vertical-menu">
        <Button
          v-for="link of links"
          :key="link.title"
          :title="link.title"
          @click="redirect(link.routeName)"
        />
      </div>
    </div>
  </scoped>
</template>

<script setup lang="ts">
  import Button from "@/components/button.vue"
  import router from "@/router"

  const links = defineModel("links", {
    default: [],
    required: false,
    type: Array<{
      routeName: string,
      title: string
    }>
  })
  
  function redirect(routeName: string) {
    router.push({
      name: routeName,
    })
  }
</script>

<style scoped>
  .vertical-navigator {
    display: grid;
    grid-template-areas:
      "horizontal-menu horizontal-menu logo"
      "vertical-menu content content";
    grid-template-columns: auto 1fr auto;
    grid-template-rows: auto 1fr;
    height: 100vh;
    margin: 0;
    overflow: hidden;
    padding: 0;
    width: 100vw;
  
    .content {
      grid-area: content;
      overflow: auto;
      padding: 1em;
    }
  
    .horizontal-menu {
      align-content: center;
      background-color: var(--theme-color-primary);
      grid-area: horizontal-menu;
    }

    .logo {
      align-content: center;
      background-color: var(--theme-color-primary);
      grid-area: logo;

      > a {
        > img {
          display: block;
          height: 3em;
          margin: 0.5em;
        }
      }
    }
  
    .vertical-menu {
      background-color: var(--theme-color-secondary);
      grid-area: vertical-menu;
    }
  }
</style>
